import React from "react";

const ContactsAppContext = React.createContext({});

export default ContactsAppContext;